import { useResolve } from '@visiba/instantiation';
import { usePresentation } from '@visiba/presentation';
import { PresentationModel, VisitsController } from './view_patient_cases.controller';
import { useParams } from 'react-router';
import { ViewNotFound } from '@view/view_not_found/view_not_found_route.component';
import { InfoViewMessaging } from './_info_view_messaging.component';

export function SelectedMessagingCase() {
	const params = useParams<'messageId'>();
	const controller = useResolve(VisitsController);
	const presentation = usePresentation(controller.presentation);
	const c = params.messageId != null ? getMessageCase(presentation, params.messageId) : null;

	if (c == null) return <ViewNotFound />;

	return <InfoViewMessaging model={c} />;
}

function getMessageCase(presentation: Readonly<PresentationModel>, id: string) {
	if (presentation.completedCases == null || presentation.ongoingCases == null) return null;

	const cases = [...presentation.completedCases.messagingCases, ...presentation.ongoingCases.messagingCases];
	const c = cases.find((c) => c.getIdentifier() === id);

	return c ?? null;
}
